import * as r from "react";
import { forwardRef as l } from "react";
import { c as a } from "./index.js-Cr0Rsuyz.mjs";
function o(e, t) {
  return /* @__PURE__ */ r.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t
  }, e), /* @__PURE__ */ r.createElement("path", {
    fill: "currentColor",
    d: "M14.116 4.116a1.25 1.25 0 1 1 1.768 1.768L9.767 12l6.117 6.116a1.25 1.25 0 1 1-1.768 1.768l-7-7a1.25 1.25 0 0 1 0-1.768z"
  }));
}
var w = a(/* @__PURE__ */ l(o));
function i(e, t) {
  return /* @__PURE__ */ r.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: t
  }, e), /* @__PURE__ */ r.createElement("path", {
    fill: "currentColor",
    d: "M9.884 4.116a1.25 1.25 0 1 0-1.768 1.768L14.232 12l-6.116 6.116a1.25 1.25 0 1 0 1.768 1.768l7-7a1.25 1.25 0 0 0 0-1.768z"
  }));
}
var f = a(/* @__PURE__ */ l(i));
export {
  w as I,
  f as a
};
